import { AdminNamespace } from '../../../../../app/namespace';

export const ChangelogsNamespace = `${AdminNamespace}/system/changelogs`;
